import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import OdataReaderForm from '../forms/odata-reader-form';
import { odataReaderValidationSchema } from '../schema/odataReader.js';

export default function ODataReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'OData Reader Node Details',
        altText: 'OData Reader Node',
        defaultLabel: 'OData Reader Node',
      }}
    >
      <CommonNode FormComponent={OdataReaderForm} schemaResolver={odataReaderValidationSchema} />
    </NodeProvider>
  );
}
